import { render, staticRenderFns } from "./tipodocumento-form.vue?vue&type=template&id=4151d3bb&scoped=true"
import script from "./tipodocumento-form.vue?vue&type=script&lang=js"
export * from "./tipodocumento-form.vue?vue&type=script&lang=js"
import style0 from "./tipodocumento-form.vue?vue&type=style&index=0&id=4151d3bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151d3bb",
  null
  
)

export default component.exports